<div class="people" aria-live="polite" [attr.aria-busy]="store.isLoading">
  @if (store.feedItems.length) {
    <ul class="people__grid">
      @for (person of store.feedItems; track person.id) {
        <li class="card people__card">
          <a class="people__link" uiSref="profile.about" [uiParams]="{ profileId: person.slug }">
            <img [src]="person.avatar_url" alt="" width="64" height="64" />
            <b>{{ person.name }}</b>
            <span>{{ subtitle(person) }}</span>
          </a>
          @if (person.current_user_permissions?.follow) {
            <ut-community-follow-btn [user]="person" design="2026" size="sm" (followChange)="followChange.emit($event)"></ut-community-follow-btn>
          }
        </li>
      }
    </ul>
  } @else if (!store.isLoading) {
    <div class="card empty">
      <span class="empty__icon" aria-hidden="true"><span class="material-icons">group</span></span>
      <p class="empty__title">{{ kind === 'following' ? user.name + " isn't following anyone yet" : user.name + " doesn't have any followers yet" }}</p>
    </div>
  }

  @if (store.isLoading) {
    <ut-skeleton-list variant="people" [count]="6"></ut-skeleton-list>
  } @else if (!store.isLastPage) {
    <button type="button" class="ut-btn ut-btn--secondary more" (click)="loadMore()">View more</button>
  }
</div>
